import Axios from '@/common/require'

export default {
    GET_LOCATION_SUGGEST (store,data){
        return Axios({
            url:'/api.php/api/index/location_suggest',
            data,
            options:{
                method:'get',
                load:0,
                json:0
            }
        })
    },
    GET_COMPANY_SUGGEST (store,data){
        return Axios({
            url:'/api.php/api/index/company_suggest',
            data,
            options:{
                method:'get',
                load:0,
                json:0
            }
        })
    },
    GET_MENU_LIST (store,data){
        return new Promise((resolve,reject)=>{
            Axios({
               url:'/api.php/console/group/get',
               data,
               options:{
                   method:'post',
                   load:0,
                   json:0
               }
           }).then(dt=>{
               store.commit('SET_MENU_LIST',dt);
               resolve(dt);
           })
        })
    },
    // 行业 和 职能
    GET_INDUSTRY (store,data){
        return new Promise((resolve,reject)=>{
            Axios({
                url:'/api/index/get_function',
                data,
                options:{
                    method:'post',
                    load:0,
                    json:0
                }
            }).then(dt=>{
                resolve(dt);
            })
        })
    }

}


// WEBPACK FOOTER //
// ./src/store/actions/index.js